// Singleton QueryClient клиентского портала (S25 — введён вместе с
// `useMyContext` для /api/me/context; S28 расширил под /api/catalog/search).
// Дефолты совпадают со стилем admin app (apps/admin/src/lib/queryClient.ts) —
// единая ментальная модель для агентов, переключающихся между апп-ами.
// retry=1 для GET, refetch on focus отключён, staleTime 30s, mutations retry=0.
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
